<script setup>
import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
});

const store = useStore();
const { t } = useI18n();

const isEnabled = ref(false);
const loading = ref(false);

watch(
  () => props.inbox,
  inbox => {
    isEnabled.value = Boolean(inbox.request_read_receipt);
  },
  { immediate: true }
);

const updateInbox = async () => {
  try {
    loading.value = true;
    await store.dispatch('inboxes/updateInbox', {
      id: props.inbox.id,
      formData: false,
      channel: {
        request_read_receipt: isEnabled.value,
      },
    });
    useAlert(t('INBOX_MGMT.READ_RECEIPT.EDIT.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(error.message);
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <SettingsFieldSection
    :label="$t('INBOX_MGMT.READ_RECEIPT.TITLE')"
    :help-text="$t('INBOX_MGMT.READ_RECEIPT.NOTE_TEXT')"
    class="[&>div]:!items-start [&>div>label]:mt-1 mb-4"
  >
    <form @submit.prevent="updateInbox">
      <label for="toggle-request-read-receipt">
        <input
          id="toggle-request-read-receipt"
          v-model="isEnabled"
          type="checkbox"
          class="me-1"
          name="toggle-request-read-receipt"
        />
        {{ $t('INBOX_MGMT.READ_RECEIPT.TOGGLE_AVAILABILITY') }}
      </label>
      <p>{{ $t('INBOX_MGMT.READ_RECEIPT.TOGGLE_HELP') }}</p>
      <NextButton
        type="submit"
        :label="$t('INBOX_MGMT.READ_RECEIPT.EDIT.BUTTON_TEXT')"
        :is-loading="loading"
      />
    </form>
  </SettingsFieldSection>
</template>
